import {
  Col,
  ColType,
  Crud,
  CrudAction,
  CrudApi,
  CrudOption,
} from "../../comp/crud";
import {
  ApiClient,
  displayLeadAssignStatus,
  displayLeadStatus,
  getLeadAssignStatusOpt,
  getLeadStatusOpt,
  displayLeadType,
  getLeadTypeOpt,
  Lead,
  phoneHide,
} from "../../api/ApiClient";
import React, { useContext, useEffect, useState, useRef } from "react";
import {
  displayStar,
  formatDuration,
  formatRelativeTime,
  formatAmountZhCn,
} from "../../utils";
import {
  Button,
  Form,
  Modal,
  Toast,
  TagInput,
  withField,
  Typography,
} from "@douyinfe/semi-ui";
import { TextCell, TextCellRemark } from "../../comp/cell";
import { FormApi } from "@douyinfe/semi-ui/lib/es/form";

import "../clientConfig/index.scss";
import {IconModalStroked} from "@douyinfe/semi-icons";

let apiClient = ApiClient.getDefault();

export default function LeadVisitSignLog() {
  const [teamMembersTree, setTeamMembersTree] = useState([] as any[]);
  const [crudApi, setCrudApi] = useState(undefined as undefined | CrudApi);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [showModifyModal, setShowModifyModal] = useState(false);
  const [assignFormApi, setAssignFormApi] = useState(
    undefined as undefined | FormApi
  );
  const [modifyFormApi, setModifyFormApi] = useState(
    undefined as undefined | FormApi
  );

  const [selectedLeads, setSelectedLeads] = useState([] as any[]);
  const [assignSaving, setAssignSaving] = useState(false);
  const [saving, setSaving] = useState(false);
  const [canUpdate, setCanUpdate] = useState(false);
  const role = localStorage.getItem("role");
  const username = localStorage.getItem("username");

  const getConfirmStatusOpts = async (): Promise<CrudOption[]> => {
    const statusOpts: any = [
      {
        label: "已确认",
        value: "CONFIRMED",
        key: 1,
      },
      {
        label: "未确认",
        value: "NOT_CONFIRM",
        key: 0,
      },
    ];
    return statusOpts;
  };
  const getIsInPoolOpts = async (): Promise<CrudOption[]> => {
    const statusOpts: any = [
      {
        label: "非公海",
        value: 0,
        key: 1,
      },
      {
        label: "公海",
        value: 1,
        key: 0,
      },
    ];
    return statusOpts;
  };

  let cols: Col[] = [
    {
      name: "确认状态",
      key: "confirmStatus",
      hideInCreate: true,
      showInFilter: true,
      hideInList: true,
      type: ColType.SELECT,
      getOptions: () => getConfirmStatusOpts(),
    },
    {
      name: "是否在公海",
      key: "isInPool",
      hideInCreate: true,
      showInFilter: true,
      hideInList: true,
      type: ColType.SELECT,
      getOptions: () => getIsInPoolOpts(),
    },
    {
      name: "客户ID",
      key: "leadId",
      width: 80,
      showInFilter: false,
      hideInEdit: false,
      hidden: true,
      type: ColType.STRING,
    },
    {
      name: "客户名称",
      key: "leadName",
      showInFilter: true,
      hideInEdit: true,
      type: ColType.STRING,
      width: 80,
    },
    {
      name: "客户手机",
      key: "leadMobile",
      width: 100,
      showInFilter: true,
      optional: true,
      hideInEdit: true,
      type: ColType.STRING,
      render: (value, index) => {
        if (role == "foreground") {
          return <Typography.Text>{phoneHide(value)}</Typography.Text>;
        } else {
          return <Typography.Text>{value}</Typography.Text>;
        }
      },
    },
    {
      name: "星级",
      key: "star",
      width: 50,
      colSort: 5,
      showInFilter: true,
      hideInCreate: true,
      hideInEdit: true,
      render: (a) => displayStar(a),
      getOptions: () =>
        Promise.resolve([
          { label: "0星", value: "0", key: "0" },
          { label: "1星", value: "1", key: "1" },
          { label: "2星", value: "2", key: "2" },
          { label: "3星", value: "3", key: "3" },
          { label: "4星", value: "4", key: "4" },
          { label: "5星", value: "5", key: "5" },
        ]),
      type: ColType.SELECT,
    },
    {
      name: "城市",
      optional: true,
      key: "city",
      width: 60,
      showInFilter: true,
      hideInEdit: true,
      type: ColType.SELECT,
      getOptions: () => apiClient.getDictAsOpts("city"),
    },
    {
      name: "销售",
      optional: true,
      hideInList: true,
      hideInEdit: true,
      key: "saleId",
      type: ColType.STRING,
    },
    {
      name: "销售",
      optional: true,
      key: "saleName",
      width: 80,
      showInFilter: true,
      hideInEdit: true,
      type: ColType.STRING,
    },
    {
      name: "当前销售",
      optional: true,
      key: "currSaleName",
      width: 90,
      showInFilter: false,
      hideInEdit: true,
      type: ColType.STRING,
    },
    {
      name: "资质",
      key: "remark",
      colSort: 7,
      type: ColType.STRING,
      width: 230,
      hideInCreate: true,
      showInFilter: true,
      hideInEdit: true,
      render: (a, b, c) => <TextCell text={b.remark} width={200} />,
    },
    {
      name: "登记时间",
      optional: true,
      key: "createdAt",
      width: 160,
      showInFilter: true,
      hideInEdit: true,
      type: ColType.DATE_RANGE,
    },

    {
      name: "确认时间",
      optional: false,
      key: "confirmAt",
      width: 160,
      type: ColType.DATETIME,
    },
  ];

  useEffect(() => {
    let currUsername;
    if (role == "op_manager" || role == "monitor" || role == "foreground") {
      currUsername = "root";
    } else {
      currUsername = username;
    }
    apiClient
      .getTeamMemberTreeAsOptsOfAny(currUsername)
      .then((opts) => setTeamMembersTree(opts));

    if (role == 'root') {
      setCanUpdate(true);
    }


    return () => { };
  }, []);

  const handleAssignButtonClick = (row: any) => {
    setSelectedLeads([{ id: row.leadId, name: row.leadName }]);
    setShowAssignModal(true);
  };

  const assignAction: CrudAction = {
    name: "分配客户",
    action: handleAssignButtonClick,
  };

  const handleModifyButtonClick = (row: any) => {
    setSelectedLeads([{ id: row.leadId, name: row.leadName, visitLogId: row.id}]);
    setShowModifyModal(true);
  };

  const modifyAction: CrudAction = {
    name: "修改上门销售",
    action: handleModifyButtonClick,
  };

  const handleAssignClick = async () => {
    setAssignSaving(true);
    try {
      await assignFormApi!.validate();
      await apiClient.request(
        "/leads/assign",
        "POST",
        undefined,
        assignFormApi!.getValues()
      );
      setSelectedLeads([]);
      crudApi?.refresh();

      setAssignSaving(false);
      setShowAssignModal(false);
    } catch (e) {
      setAssignSaving(false);
    }
  };

  const handleModifyClick = async () => {
    setAssignSaving(true);
    try {
      let params = {
        ...
        modifyFormApi!.getValues(),
        id:selectedLeads[0].visitLogId
      }
      await modifyFormApi!.validate();
      await apiClient.request(
        "/leadVisitSignLog/modifySale",
        "POST",
        undefined,
        params
      );
      setSelectedLeads([]);
      crudApi?.refresh();

      setAssignSaving(false);
      setShowModifyModal(false);
    } catch (e) {
      setAssignSaving(false);
    }
  };


  const handleConfirmSignClick = (row: any) => {
    if (saving) {
      return;
    }
    //校验当前销售是否为空
    if (!row.currSaleId || row.currSaleId === undefined) {
      Toast.info("该客户没有销售跟进，请先分配客户");
      return;
    }
    Modal.confirm({
      title: "该客户的顾问为：" + row.currSaleName + "，是否确认登记?",
      content: "",
      onOk: async () => {
        setSaving(true);
        try {
          await apiClient.request(
            "/leadVisitSignLog/confirmSign",
            "POST",
            undefined,
            {
              id: row.id,
              leadId: row.leadId,
            }
          );
          Toast.info("确认登记成功");

          crudApi?.refresh();
          setSaving(false);
        } catch (e) {
          setSaving(false);
        }
      },
    });
  };

  const confirmAction: CrudAction = {
    name: "确认登记",
    action: handleConfirmSignClick,
  };

  const handleViewLeadDetailClick = (a: any) => {
    const w = window.open("about:blank");
    if (w != null) {
      const data = {
        id: a.leadId,
        ids: [],
        viewMode: true,
        visitMode: true,
        leadFrom: "visitSignLog",
        queryParams: crudApi?.getQueryParams(),
      };
      w.location.href =
        "/#/leadDetailNew?data=" +
        encodeURIComponent(JSON.stringify(data));
    }
  }

  const viewLeadDetailAction: CrudAction = {
    name: "详情",
    action: handleViewLeadDetailClick,
  };

  const renderLabel = (label:any, item:any) => (
      <div style={{
        padding: '6px 8px',
        lineHeight: 1.0
      }}>
        <div style={{
          fontWeight: 500,
          color: 'var(--semi-color-text-0)',
          fontSize: 14
        }}>
          {label}
          <span style={{
            fontSize: 12,
            color: 'var(--semi-color-text-2)',
            marginLeft: 10
          }}>
                {item.labelSubText}
            </span>
        </div>
      </div>
  );

  return (
    <div>
      <Modal
          icon={<IconModalStroked size={"extra-large"} style={{ color: 'blue' }}/>}
        style={{ width: 600, height: 600 }}
        title="分配客户"
        visible={showAssignModal}
        okText="分配"
        confirmLoading={assignSaving}
        onOk={handleAssignClick}
        onCancel={() => setShowAssignModal(false)}
      >
        <Form getFormApi={(formApi) => setAssignFormApi(formApi)}>

          <Form.TreeSelect
            placeholder="请选择分配给谁"
            rules={[{ required: true, message: "请填写" }]}
            style={{ width: "100%" }}
            field="assignToIds"
            label="销售"
            //defaultExpandAll
            checkRelation="unRelated"
            leafOnly
            multiple
            treeData={teamMembersTree}
            filterTreeNode
            showFilteredOnly={true}
            searchPlaceholder="请输入关键字开始搜索"
            renderLabel={renderLabel}
            autoAdjustOverflow={false}
            virtualize={{
              itemSize: 28,
              height: 400
            }}
          ></Form.TreeSelect>

          <Form.Select
              rules={[{ required: true, message: "请填写" }]}
              disabled
              initValue={selectedLeads.map((l) => l.id)}
              style={{ width: "100%" }}
              multiple
              field="leadIds"
              label="客户"
          >
            {selectedLeads.map((l) => (
                <Form.Select.Option key={l.id + ""} value={l.id}>
                  {l.name}
                </Form.Select.Option>
            ))}
          </Form.Select>

        </Form>
      </Modal>
      <Modal
          icon={<IconModalStroked size={"extra-large"} style={{ color: 'blue' }}/>}
        style={{ width: 600, height: 600 }}
        title="修改上门销售"
        visible={showModifyModal}
        okText="修改"
        confirmLoading={assignSaving}
        onOk={handleModifyClick}
        onCancel={() => setShowModifyModal(false)}
      >
        <Form getFormApi={(formApi) => setModifyFormApi(formApi)}>
          <Form.Select
            rules={[{ required: true, message: "请填写" }]}
            disabled
            initValue={selectedLeads.length>0?selectedLeads[0].id: undefined}
            style={{ width: "100%" }}
            field="leadId"
            label="客户"
          >
            {selectedLeads.map((l) => (
              <Form.Select.Option key={l.id + ""} value={l.id}>
                {l.name}
              </Form.Select.Option>
            ))}
          </Form.Select>

          <Form.TreeSelect
            placeholder="请选择上门销售"
            rules={[{ required: true, message: "请填写" }]}
            style={{ width: "100%" }}
            field="saleId"
            label="销售"
            checkRelation="unRelated"
            leafOnly
            treeData={teamMembersTree}
            filterTreeNode
            showFilteredOnly={true}
            searchPlaceholder="请输入关键字开始搜索"
            extraText={
              <div
                style={{
                  color: 'var(--semi-color-link)',
                  fontSize: 14,
                  userSelect: 'none',
                  cursor: 'pointer'
                }}
              >
                只会修改当前客户上门的销售，不会把客户分配给该销售
              </div>
            }
            renderLabel={renderLabel}
            autoAdjustOverflow={false}
            virtualize={{
              itemSize: 28,
              height: 400
            }}
          ></Form.TreeSelect>
        </Form>
      </Modal>
      <Crud
        getCrudApi={(crudApi) => {
          setCrudApi(crudApi);
        }}
        canUpdate={canUpdate}
        canCreate={false}
        name="上门登记"
        entityKey="leadVisitSignLog"
        pageSize={50}
        rowActionWidth={200}
        cols={cols}
        select={false}
        getRowActions={(row) => {
          let actions = [];
          if (role != "foreground") {
            actions.push(viewLeadDetailAction);
          }
          if (role == "foreground" || role == "root" || role == "op_manager") {
            actions.push(assignAction);
            actions.push(modifyAction);
          }
          if (!row.confirmAt) {
            actions.push(confirmAction);
          }
          return actions;
        }}
      />
    </div>
  );
}
